import { Route, Switch, useHistory, Redirect } from 'react-router-dom';
import { MY_APPS_ROUTES } from '../config/routes';
import { useFeature } from 'lib/featureFlags/features';
import { useAzureFeatureFlags } from 'lib/featureFlags/azure-feature-flags';
import { LoadingScreen } from 'features/common/components/LoadingScreen';
import { getBaseMarketplaceAppUrl } from 'features/marketplace/config/env';
import { fetchLastSuccessfulLoginOrganizationId } from 'features/common/auth/auth0Storage';
import { useFetchTenantsData } from 'features/developer/core/auth/hooks/useFetchTenantsData';
import { useEffect } from 'react';
import { IframeWithNavigationSync } from 'features/common/components/IframeWithNavigationSync';

export const MyAppsRoutes: React.FC = () => {
  const { isLoading } = useAzureFeatureFlags({ enabled: true });
  const featureEnabled = useFeature('MARKETPLACE');
  const history = useHistory();

  const { tenantsData, isLoading: tenantsLoading } = useFetchTenantsData();

  // Clean up URL by removing appId parameter when navigating to My Apps
  useEffect(() => {
    const searchParams = new URLSearchParams(history.location.search);
    if (searchParams.has('appId')) {
      searchParams.delete('appId');
      const newSearch = searchParams.toString();
      const newUrl = newSearch
        ? `${history.location.pathname}?${newSearch}`
        : history.location.pathname;
      history.replace(newUrl);
    }
  }, [history]);

  if (isLoading || tenantsLoading) {
    return <LoadingScreen data-testid='loading-component' message='Loading…' />;
  }
  if (!featureEnabled && !isLoading) {
    return <Redirect to='/no-access' />;
  }

  const marketplaceTenant = tenantsData[0]?.id;

  const organizationId = fetchLastSuccessfulLoginOrganizationId();
  const marketplaceAppUrl = getBaseMarketplaceAppUrl();
  const myAppsHomepageUrl = `${marketplaceAppUrl}/my-apps/?organization=${organizationId}&tenantId=${marketplaceTenant}`;

  return (
    <Route path={MY_APPS_ROUTES.ROOT}>
      <Switch>
        <Route
          exact
          path={`${MY_APPS_ROUTES.ROOT}`}
          render={() => (
            <IframeWithNavigationSync
              src={myAppsHomepageUrl}
              title='My Apps Homepage Iframe'
              debugMode={process.env.NODE_ENV === 'development'}
            />
          )}
        />
      </Switch>
    </Route>
  );
};
